import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type GetTermsAndConditionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetTermsAndConditionsQuery = {
  __typename?: 'Query';
  results?: { __typename?: 'TermsAndConditionsVersion'; version?: string | null; text?: string | null } | null;
};

export type GetPrivacyPolicyQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetPrivacyPolicyQuery = {
  __typename?: 'Query';
  results?: {
    __typename?: 'PrivacyPolicyVersion';
    text?: string | null;
    version?: string | null;
    cookies?: string | null;
  } | null;
};

export type GetSellingConditionsQueryVariables = Types.Exact<{ [key: string]: never }>;

export type GetSellingConditionsQuery = {
  __typename?: 'Query';
  results?: { __typename?: 'SellingConditionsVersion'; text?: string | null; version?: string | null } | null;
};

export const GetTermsAndConditionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getTermsAndConditions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'text' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetTermsAndConditionsGQL extends Apollo.Query<
  GetTermsAndConditionsQuery,
  GetTermsAndConditionsQueryVariables
> {
  document = GetTermsAndConditionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetPrivacyPolicyDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getPrivacyPolicy' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'privacyPolicy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'version' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cookies' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetPrivacyPolicyGQL extends Apollo.Query<GetPrivacyPolicyQuery, GetPrivacyPolicyQueryVariables> {
  document = GetPrivacyPolicyDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}

export const GetSellingConditionsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getSellingConditions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'results' },
            name: { kind: 'Name', value: 'sellingConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'version' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class GetSellingConditionsGQL extends Apollo.Query<
  GetSellingConditionsQuery,
  GetSellingConditionsQueryVariables
> {
  document = GetSellingConditionsDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
